<script setup lang="ts">
import GenericError from '~/components/user-interface/generic-error.vue';
import GenericLoader from '~/components/user-interface/generic-loader.vue';
import { useWinnersData } from '~/composables/useStates/useWinnersData';
const { winnersLoading, bigWinners } = useWinnersData();
</script>
<template>
  <LazyWinnersSectionHeader
    title="big-winners"
    alt="Big Winners"
    icon-name="winnersIcon"
  />
  <GenericLoader v-if="winnersLoading" :standalone="true" />
  <div v-else class="sm:mx-0 sm:my-3">
    <LazyWinnersBigWinnersCarousel
      v-if="bigWinners?.length > 0"
      :vertical-navigation="false"
      title-class="text-base"
      :display-title="false"
      :animate="false"
    />
    <GenericError v-else :scroll-to-view="false">
      {{ $t('big-winners-list-empty') }}
    </GenericError>
  </div>
</template>
